import { fetchJSONWithTimeout } from '@noths/polaris-client-utils';

import { PUBLIC_API_BASE_PATH } from 'src/constants/environment';
import type { ProductReviewsSummaryResponse } from './types';

export const PRODUCT_REVIEWS_API_PATH = `${PUBLIC_API_BASE_PATH}product-reviews`;

// This route runs on our own pods, whose upstream calls are themselves bounded
// at 500ms, so 5000ms leaves room for a healthy round trip while stopping the
// browser holding a connection open against a saturated pod.
const CLIENT_TIMEOUT_MS = 5000;

export const fetchProductReviewsSummaryClient = async (
  productCode: number,
): Promise<ProductReviewsSummaryResponse | null> => {
  const response = await fetchJSONWithTimeout(`${PRODUCT_REVIEWS_API_PATH}/${productCode}`, {
    timeout: CLIENT_TIMEOUT_MS,
  });

  if (!response.ok) {
    return null;
  }

  return response.json();
};
